import { DialogBody } from "@blueprintjs/core";
import { useWrapup } from "../wrapupcontext";
import { WrapupModuleMapData } from "@/src/server/models/seasonal/wrapup/modules/getwrapup";
import getItemById from "@/src/util/getItemById";
import pluralize from "@/src/util/pluralize";
import styles from './wrapup.module.css';

export default function WrapupModuleMapsComponent(): React.ReactNode {
    const { wrapupData } = useWrapup();

    const data = wrapupData.data.map as WrapupModuleMapData;
    const topMapId = data.topMap.mapId;
    const topMap = getItemById(wrapupData.maps, topMapId);

    return <DialogBody className={styles.dialogBody}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start' }}>
            <h1>Maps</h1>
            <h3>You played a lot of maps this year, but one was your favorite:</h3>
            <picture>
                <img
                    src={`/api/map/getthumbnail?mapId=${topMapId}`}
                    alt={topMap.name}
                    draggable={false}
                    style={{
                        border: '2px white solid',
                        boxShadow: '0 0 10px black',
                    }}
                    width={128}
                    height={128}
                />
            </picture>
            <h3>You played the map {topMap.name} {pluralize(data.topMap.totalPlays, 'time')}!</h3>
            <h3>Your rank: {data.topMap.rank} of {data.topMap.totalUsers}</h3>
            <h3>That puts you in the top {Math.round(data.topMap.rank * 100 / data.topMap.totalUsers)}% of {topMap.name} players</h3>
        </div>
    </DialogBody>
}
